import { render, staticRenderFns } from "./SupportBlock.vue?vue&type=template&id=2570b5fd&scoped=true&"
import script from "./SupportBlock.vue?vue&type=script&lang=js&"
export * from "./SupportBlock.vue?vue&type=script&lang=js&"
import style0 from "./SupportBlock.vue?vue&type=style&index=0&id=2570b5fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570b5fd",
  null
  
)

export default component.exports